class Layer {

  constructor(mapGL, isVisible = false) {
    this.mapGL = mapGL;
    this.isVisible = isVisible;
    this.name = '';
    this.minZoom = 10;
    this.layerIds = [];
    this.clickable = false;
  }

  load() {}

  addListenersToLayer() {}

  enable() {
    this.layerIds.forEach(function(layer) {
      if (this.mapGL.getMapObject().getLayer(layer)) {
        this.mapGL.getMapObject().setLayoutProperty(layer, 'visibility', 'visible');
      }
    }, this);

    if (this.mapGL.getMapObject().getZoom() < this.minZoom) {
      this.mapGL.getMapObject().flyTo({zoom: this.minZoom});
    }

    this.isVisible = true;
  }

  disable() {
    this.layerIds.forEach(function(layer){
      if (this.mapGL.getMapObject().getLayer(layer)) {
        this.mapGL.getMapObject().setLayoutProperty(layer, 'visibility', 'none');
      }
    }, this);

    this.isVisible = false;
  }

  getName() {
    return this.name;
  }

}
